import React, { Component } from "react";
import { DataTable, OutPutResult, Spinner, TruckingModal, ExportToExcel } from '@operations/shared';
import { Button, Col, Form, InputNumber, Row, message, DatePicker, Select, Input, Checkbox, Tag } from "antd";
import { FormInstance } from "antd/es/form";
import { CloseOutlined, ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import { request } from "../apis";
import { connect } from "react-redux";
import moment from "moment";
import helper from "../utils/helper";
import { errorMessage } from "../utils/commonStringsConsts";
import { changeRequestStatusApi } from "../utils/apisConsts";
import { exportTextFile } from "../utils/exportTextFile";
import { getRegion } from "../components/regionWrapper";
import { Region } from "../utils/commonInterfaces";

const { RangePicker } = DatePicker;

interface Props {
  request: any;
}
enum statusesIDsEnum {
  transferring = 9,
  processing = 2
}
enum sheetsTypesEnum {
  allValid = "all",
  bankMisr = "bankMisr",
  CIB = "CIB",
  meeza = "meeza",
  cash = "cash",
  mobileWallet = "mobileWallet",
  arabyBank = "arabyBank",
  hsbcKsa = "hsbcKsa",
  allBanks = "allBanks",
};
enum servicesGroupsEnum {
  SALARY_ADVANCE_AND_MONEY_TRANSFER = 10
};

class ViewRequestsList extends Component<Props> {
  formStatusRef = React.createRef<FormInstance>();
  formFilterRef = React.createRef<FormInstance>();
  formRef: any = React.createRef<any>();
  selectRef: any = React.createRef<FormInstance>();
  commentRef: any = React.createRef<FormInstance>();
  region: Region = getRegion() ?? Region.EG;

  state = {
    requestsList: [
      {
        advanceID: "1",
        userID: "46646",
        userName: "Youssef",
        companyName: "Nowpay",
        amount: "4000",
        dateOfRequest: "2022/2/1",
        transactionStatus: "approved",
        reasonName: "high amount",
        numOfMonths: 3,
        serviceTypeName: "RechargeMobile",
      },
    ],
    tableLoading: false,
    pageLoading: true,
    errorView: false,
    errorMessage: "",
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    columns: [],
    canResetFilter: false,
    showBlockingIssuesCheckBox: false,
    filters: {
      userID: null,
      requestID: null,
      statusID: null,
      dateFrom: null,
      dateTo: null,
      companyID: null,
      deployed: null,
      serviceGroupID: null,
      isACH: false,
    },
    bankMisrData: [],
    cibData: [],
    meezaData: [],
    statuses: [],
    defaultStatusName: '',
    isDownloadable: false,
    currentStatus: 2,
    companies: [],
    deployOptions: [
      { name: 'All Companies', id: null },
      { name: 'Not Deployed', id: '0' },
      { name: 'Deployed', id: 1 },
    ],
    selectedCompany: false,
    selectedDeployType: false,
    serviceTypes: [],
    serviceGroupIDSelected: 0,
    modalOn: false,
    selectedStatus: 0,
    advanceID: 0,
    changeStatusBtn: false,
    sheetsData: {
      allValid: [],
      bankMisr: [],
      CIB: [],
      meeza: [],
      cash: [],
      mobileWallet: [],
      arabyBank: [],
      hsbcKsa: [],
    },
    statusFilterSelected: 2,
    sheetsLoading: false,
  };

  storeRequestStatuses = async () => {
    const requestStatuses: any = await helper.getRequestsStatuses();
    if (requestStatuses.data.status === 200) {
      this.setState({
        statuses: requestStatuses.data.advanceStatus,
        // isDownloadable: true,
        defaultStatusName: requestStatuses.data.advanceStatus.filter((name: any) => name.advancesStatusTypeID === 2)[0].StatusType
      });
      return
    }
    message.error(errorMessage);

  }

  getOtherSheets = () => {
    const sheets = [
      {
        name: "All valid requests",
        statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} All valid requests`,
        onClick: () => this.getSheetData(sheetsTypesEnum.allValid),
      },
      {
        name: "Bank misr Requests list",
        statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} Bank misr Requests list`,
        onClick: () => this.getSheetData(sheetsTypesEnum.bankMisr),
      },
      {
        name: "CIB Requests list",
        statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} CIB Requests list`,
        onClick: () => this.getSheetData(sheetsTypesEnum.CIB),
      },
      {
        name: "Meeza Requests list",
        statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} Meeza Requests list`,
        onClick: () => this.getSheetData(sheetsTypesEnum.meeza),
      },
      {
        name: "Cash Requests list",
        statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} Cash Requests list`,
        onClick: () => this.getSheetData(sheetsTypesEnum.cash),
      },
      {
        name: "Mobile Wallet Requests list",
        statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} Mobile Wallet Requests list`,
        onClick: () => this.getSheetData(sheetsTypesEnum.mobileWallet),
      },
      {
        name: "Araby Bank Requests list",
        statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} Araby Bank Requests list`,
        onClick: () => this.getSheetData(sheetsTypesEnum.arabyBank),
      },
      {
        name: "HSBC Bank Requests list",
        statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} HSBC Bank Requests list`,
        onClick: () => this.getSheetData(sheetsTypesEnum.hsbcKsa),
      },
    ];

    return sheets?.slice(0, -1);
  };

  storeCompanies = async () => {
    const getCompanies: any = await helper.getCompanies();
    if (getCompanies.data.status === 200) {
      this.setState({ companies: getCompanies.data.data })
      return
    }
    message.error(errorMessage);
  }

  storeServiceTypes = async () => {

    try {
      const getServiceTypes: any = await helper.getServiceTypes();
      if (getServiceTypes.status !== 200) {
        message.error(`${errorMessage} with service types`);
        return
      }
      this.setState({ serviceTypes: getServiceTypes?.data?.data?.servicesGroups });
    } catch (error) {
      message.error(`${errorMessage} with service types`);
    }


  }
  getRequests = async (sheetType?: string) => {

    const date = new Date()
    date.setDate(date.getDate() - 30)
    const params = {
      ...(!sheetType && {
        ...this.state.filters,
        requestStatusID: this.state.statusFilterSelected ? this.state.statusFilterSelected : statusesIDsEnum.processing,
        rowsPerPage: this.state.pagination.pageSize,
        pageNum: this.state.pagination.current,
      }),
      ...(sheetType && {
        ...((sheetType !== sheetsTypesEnum.allValid) && { sheetType }),
        isACH: this.state.filters.isACH,
        dateFrom: this.state.filters.dateFrom,
        dateTo: this.state.filters.dateTo,
        requestStatusID: this.state.statusFilterSelected === statusesIDsEnum.transferring ? statusesIDsEnum.transferring : statusesIDsEnum.processing
      }),
    };
    try {
      !sheetType && this.setState({ tableLoading: true });
      const res = await this.props.request({
        url: "/requests/getAllRequests",
        method: "GET",
        params,
      });

      if (res.data.status === 200) {

        // this.setState({ columns });
        if (sheetType) {
          return res.data.advances
        }
        let listOFRequests = Array.isArray(res.data.advances) && res.data.advances.map((requests: any) => {
          return {
            ...requests,
            amount: helper.amountFormatter(requests?.amount) + (this.region === Region.SE ? ' SAR' : ' EGP'),
            recipientPhone: requests?.recipientPhone ? requests?.recipientPhone : 'NA',
            recipientName: requests?.recipientName ? requests?.recipientName : 'NA',
            bankSwiftCode: requests?.bankSwiftCode ? requests?.bankSwiftCode : 'NA'
          }

        })
        this.setState({
          pageLoading: false,
          tableLoading: false,
          requestsList: listOFRequests,
          pagination: {
            ...this.state.pagination,
            total: res.data.advanceCount,
          },
          // isDownloadable: this.state.currentStatus === 2 || this.state.currentStatus === 9 ? true : false
        });
        // this.generateSheetsObjects(res.data.advances);
      } else {
        this.setState({
          errorMode: true,
          pageLoading: false,
          tableLoading: false,
          errorMessage: res.data.message,
        });
      }
    } catch (e) {
      this.setState({
        errorView: true,
        pageLoading: false,
        tableLoading: false,
      });
    }
  };

  generateSheetsObjects = async (bankType: sheetsTypesEnum) => {
    const banks = [sheetsTypesEnum.CIB, sheetsTypesEnum.bankMisr, sheetsTypesEnum.arabyBank, sheetsTypesEnum.hsbcKsa];
    const data = await this.getRequests(
      bankType === sheetsTypesEnum.meeza ? sheetsTypesEnum.meeza :
        bankType === sheetsTypesEnum.mobileWallet ? sheetsTypesEnum.mobileWallet :
          bankType === sheetsTypesEnum.cash ? sheetsTypesEnum.cash :
            [...banks, sheetsTypesEnum.allBanks].includes(bankType) ? 'bank' : sheetsTypesEnum.allValid
    );

    if (bankType === sheetsTypesEnum.allBanks) { // to reduce number of called requests
      // The return order [sheetsTypesEnum.CIB, sheetsTypesEnum.bankMisr, sheetsTypesEnum.arabyBank]
      return banks.map((sheetType: sheetsTypesEnum) => this.formalizeBankSheetData(data, sheetType));
    } else {
      return this.formalizeBankSheetData(data, bankType);
    }
  };

  formalizeBankSheetData(data: any, bankType: sheetsTypesEnum) {
    const sheet = [];
    if (data) {
      if (!data.length) { return []; }
      if (bankType === sheetsTypesEnum.cash) { return data; }

      for (let i = 0; i < data.length; i++) {
        switch (bankType) {
          case sheetsTypesEnum.CIB: {
            sheet.push({
              TransactionID: data[i]?.advanceID,
              CreditorName: data[i]?.accountHolderName,
              CreditorAccountNumber: data[i]?.accountNumber,
              CreditorBank: data[i]?.bankName,
              CreditorBankBranch: "",
              TransactionAmount: Number(data[i]?.amount),
              TransactionPurpose: "",
              Comments: data[i]?.comment.replace(/&/g, ''),
              ReceiverEmail: "",
              SMSMobileNumber: data[i]?.phone,
            });

            break;
          }
          case sheetsTypesEnum.bankMisr: {
            sheet.push({
              InstructionID: data[i]?.advanceID,
              EndtoEndId: "",
              NationalID: "",
              CreditorName: data[i]?.accountHolderName,
              CreditorAccountNumber: data[i]?.accountNumber,
              CreditorBank: data[i]?.bankName,
              CreditorBankBranch: "",
              TransactionAmount: Number(data[i]?.amount),
              TransactionPurpose: "",
              Comments: data[i]?.comment.replace(/&/g, ''),
              Email: "",
            });

            break;
          }
          case sheetsTypesEnum.meeza: {
            sheet.push({
              NationalID: data[i]?.NationalID,
              CreditorName: data[i]?.CreditorName,
              CreditorAccountNumber: data[i]?.CreditorAccountNumber,
              CreditorBank: data[i]?.CreditorBank,
              CreditorBankBranch: data[i]?.CreditorBankBranch,
              TransactionAmount: Number(data[i]?.TransactionAmount),
              Comments: data[i]?.Comments.replace(/&/g, ''),
              Email: data[i]?.Email,
              Mobile: data[i]?.Mobile,
              SMS: data[i]?.SMS,
            });

            break;
          }
          case sheetsTypesEnum.arabyBank: {
            sheet.push({
              'Payment Serial Number': i + 1,//
              'Transaction Reference': this.region === Region.SE ? data[i]?.TransactionReference?.toString().replace(/\(\)&-,_/g, ' ')
                : data[i]?.TransactionReference?.toString().replace(helper.regexValidation.arabyBankRegex, ' ').trim(),//nothing
              'Customer Reference No': this.region === Region.SE ? data[i]?.advanceID?.toString().replace(/\(\)&-,_/g, ' ')
                : data[i]?.advanceID?.toString().replace(helper.regexValidation.arabyBankRegex, ' ').trim(),//nothing
              'Debit Account No.': '5004646277439',
              'Value Date': helper.replaceTheDate('-', Date()),
              'Transaction Currency': this.region === Region.SE ? 'SAR' : 'EGP',
              'Payment Amount': Number(data[i]?.amount),
              'Beneficiary Bank Swift Code / IFSC Code': this.region === Region.SE ? data[i]?.bankSwiftCode?.toString().replace(/\(\)&-,_/g, ' ')
                : data[i]?.bankSwiftCode?.toString().replace(helper.regexValidation.arabyBankRegex, ' ').trim(),
              'Beneficiary Name': this.region === Region.SE ? data[i]?.beneficiaryName?.toString().replace(/\(\)&-,_/g, ' ') ?? ''
                : data[i]?.beneficiaryName?.toString().replace(helper.regexValidation.arabyBankRegex, ' ').trim() ?? '',
              'Beneficiary Account No.': this.region === Region.SE ? data[i]?.accountNumber?.toString().replace(/\(\)&-,_\s/g, ' ')
                : data[i]?.accountNumber?.toString().replace(helper.regexValidation.arabyBankRegex, ''),
              'Beneficiary Addr. Line 1': data[i]?.BeneficiaryAddrLine1,// empty
              'Beneficiary Addr. Line 2': data[i]?.BeneficiaryAddrLine2,// empty
              'Beneficiary Addr. Line 3': data[i]?.BeneficiaryAddrLine3,// empty
              'Purpose Code': '19',
              'Purpose Of Payment': data[i]?.companyID?.toString().replace(/\(\)&-,_/g, '') + " " + data[i]?.advanceID.toString().replace(/\(\)&-,_/g, ''),
              'Charge Account No': '5004646277439',
              'Charge Type': 'SHA',
              'Deal Reference No': this.region === Region.SE ? data[i]?.DealReferenceNo?.toString().replace(/\(\)&-,_/g, ' ')
                : data[i]?.DealReferenceNo?.toString().replace(helper.regexValidation.arabyBankRegex, ' ').trim(), //empty
              'Payment Type': 'ACH',
            });

            break;
          }
          case sheetsTypesEnum.hsbcKsa: {
            this.region === Region.SE ?
              sheet.push({
                'TRANSACTION_CODE': 'NPYR',
                'REFERENCE': `${new Date()?.toISOString()?.slice(2, 10)?.replace(/-/g, '')}${data[i]?.advanceID}`,
                'DEBIT_ACCOUNT': 90043,
                'BENEFICIARY_NAME': data[i]?.accountHolderName?.trim().replace(/\s+/g, ' '),
                'BENEFICIARY_STREET_ADDRESS1': 'King Faisal Ibn Abd Al Aziz',
                'BENEFICIARY_STREET_ADDRESS2': 'AlRawabi',
                'BENEFICIARY_CITY': 'AlKhobar',
                'BENEFICIARY_STATE': 'Eastern Province',
                'BENEFICIARY_COUNTRY_CODE': 'SA',
                'BENEFICIARY_ZIP_CODE': 34421,
                'BENEFICIARY_BANK_NAME': data[i]?.bankName, //bank name

                'BENEFICIARY_BANK_ADDRESS1': 'King Abdullah Road',
                'BENEFICIARY_BANK_ADDRESS2': 'Alrawabi',
                'BENEFICIARY_BANK_CITY': 'AlKhobar',
                'BENEFICIARY_BANK_STATE': 'Eastern Province',
                'BENEFICIARY_BANK_COUNTRY_CODE': 'SA',
                'BENEFICIARY_BANK_ZIP_CODE': '34421',
                'BENEFICIARY_BANK_BIC': data[i]?.bankcbidCode,
                'BENEFICIARY_BANK_ACCOUNT': data[i]?.accountNumber?.replace(helper.regexValidation.removeSpaces, ''),
                'BENEFICIARY_BANK_CURRENCY': 'SAR',
                'CORRESPONDENT_BANK_NAME': '',
                'CORRESPONDENT_BANK_BIC': '',
                'TRANSACTION_CURRENCY': 'SAR',
                'TRANSACTION_AMOUNT': data[i]?.amount,
                'TRANSACTION_DATE': new Date()?.toISOString()?.split("T")[0]?.split("-")?.reverse()?.join("/"),
                'REASON1': `SalaryAdvance${moment().format('MMMYY')}`, ////Salary February 2025
                'REASON2': '',
                'REASON3': '',
                'REASON4': '',
                'USER_ZONE1': '',
                'USER_ZONE2': '',
                'USER_ZONE3': '',
                'USER_ZONE4': '',
                'USER_ZONE5': '',
                'FREE_TEXT1': 'SALA',
                'FREE_TEXT2': `0.00/0.00/${data[i]?.amount}/0.00/ADP/`,
                'FREE_TEXT3': `${'Nowpaybatch'}${new Date()?.toISOString()?.slice(0, 10)?.replace(/-/g, '')}`,
                'TRANSACTION_NUMBER': '',
                'EXCHANGE_PURPOSE': '',
                'EXPORT_DATE': '',
                'EXPORT_TIME': '',
                'LAST_UPDATE_DATE': '',
                'REMITTANCE_NUMBER': '',
                'REMITTANCE_BATCH_ID': '',
                'STATUS': '',
                'LAST_ACK': '',
                'BANK_STATUS': '',
                'LAST_ACK_DATE': '',
                'LAST_ACK_TIME': '',
                'CORRESPONDENT_COUNTRY_CODE': '',
                'ERP_APPROVER': '',
                'CURRENCY_BUY_FLAG': '',
                'CURRENCY_BUY_REFERENCE': '',
                'BENEFICIARY_CORP_ID_CODE': data[i]?.nationalID,
                'BENEFICIARY_THIRD_PARTY_TYPE': 27,
                'BENEFICIARY_THIRD_PARTY_VALUE': data[i]?.advanceID,
              })
              : sheet.push({
                'Staff ID': data[i]?.advanceID,
                'Amount': data[i]?.amount,
                'Staff Bank ID': data[i]?.bankSwiftCode,
                'Staff Account No.': data[i]?.accountNumber,
                'Staff Name': data[i]?.accountHolderName,
              });

            break;
          }
          case sheetsTypesEnum.mobileWallet: {
            this.region === Region.SE ?
              sheet.push({
                Name: data[i]?.recipientName,
                Amount: Number(data[i]?.amount),
                Phone: data[i]?.recipientPhone,
                Bank: "MDIGEGCX"
              })
              : sheet.push({
                TransactionID: data[i]?.advanceID,
                CreditorName: data[i]?.accountHolderName,
                CreditorAccountNumber: data[i]?.accountNumber,
                CreditorBank: "MIDG",
                CreditorBankBranch: '',
                TransactionAmount: Number(data[i]?.amount),
                TransactionPurpose: "Cash",
                Comments: data[i]?.comment,
                ReceiverEmail: '',
                SMSMobileNumber: ''
              });

            break;
          }
          case sheetsTypesEnum.allValid: {
            sheet.push({
              requestID: data[i]?.advanceID,
              moneyDeductedBefore: data[i]?.moneyDeductedBefore,
              staffID: data[i]?.staffID,
              phone: data[i]?.phone,
              username: data[i]?.accountHolderName,
              companyName: data[i]?.companyName,
              bankName: data[i]?.bankName,
              bankAccountNumber: data[i]?.accountNumber,
              amount: Number(data[i]?.amount),
              userCurrentBalance: Number(data[i]?.userCurrentBalance),
              typeOfService: data[i]?.serviceTypeName,
              userStatus: data[i]?.userStatus,
              deductionsNo: data[i]?.numOfMonths,
              date: data[i]?.dateOfRequest,
              comment: data[i]?.comment.replace(/&/g, ''),
            });

            break;
          }
          default: {
            sheet.push({
              InstructionID: data[i]?.advanceID,
              EndtoEndId: "",
              NationalID: data[i]?.accountNumber,
              CreditorName: data[i]?.userName,
              CreditorAccountNumber: "100203500381",
              CreditorBank: data[i]?.bankName,
              CreditorBankBranch: "",
              TransactionAmount: Number(data[i]?.amount),
              TransactionPurpose: "",
              Comments: data[i]?.comment.replace(/&/g, ''),
              Email: "",
            });

            break;
          }
        }
      }

    }

    return sheet;
  }

  handlePagination = (e: any) => {
    this.setState({ loading: true, pagination: e }, () => this.getRequests());
  };

  handleSearch = (values: any) => {

    if (
      !values.userID &&
      !values.requestID &&
      !values.statusID &&
      !values.reasonID &&
      !values.dateRange &&
      !values.requestStatusID &&
      !values.serviceGroupID
    ) {
      message.error(`You can't search on nothing`, 4);
      return;
    }
    this.setState(
      {
        statusFilterSelected: typeof values.requestStatusID === 'number' ? values.requestStatusID : 2,
        filters: {
          ...this.state.filters,
          isACH: (values.serviceGroupID === servicesGroupsEnum.SALARY_ADVANCE_AND_MONEY_TRANSFER) && values.isACH,
          ...(values.userID ? { userID: values.userID } : { userID: null }),
          ...(values.requestID
            ? { requestID: values.requestID }
            : { requestID: null }),
          ...(values.statusID
            ? { statusID: values.statusID }
            : { statusID: null }),
          ...(values.requestStatusID
            ? { requestStatusID: values.requestStatusID === 'Processing' ? undefined : values.requestStatusID }
            : { requestStatusID: null }),
          ...(values.serviceGroupID
            ? { serviceGroupID: values.serviceGroupID }
            : { serviceGroupID: null }),
          ...(values.companyID
            ? { companyID: values.companyID }
            : { companyID: null }),
          ...(values.deployed
            ? { deployed: values.deployed === 'All Companies' ? undefined : values.deployed }
            : { deployed: null }),
          ...(values.reasonID
            ? { reasonID: values.reasonID }
            : { reasonID: null }),
          ...(values.dateRange
            ? {
              dateFrom: moment(values.dateRange[0]._d).format(
                "YYYY/MM/DD 00:00:00"
              ),
              dateTo: moment(values.dateRange[1]._d).format(
                "YYYY/MM/DD 23:59:59"
              ),
            }
            : { dateFrom: null, dateTo: null }),
        },
        pagination: {
          ...this.state.pagination,
          current: 1,
        },
      },
      async () => {
        this.getRequests().then(() => {
          this.setState({
            canResetFilter: true,
            // isDownloadable: this.state.currentStatus === 2 ? true : false 
          });
        });

        if (values.serviceGroupID === servicesGroupsEnum.SALARY_ADVANCE_AND_MONEY_TRANSFER && this.region === Region.SE) {
          await this.setSheetsData();
        } else if (values.serviceGroupID === servicesGroupsEnum.SALARY_ADVANCE_AND_MONEY_TRANSFER && this.region === Region.EG) {
          this.setState({ sheetsLoading: true });
          try {
            await this.setSheetsData();
          } finally {
            this.setState({ sheetsLoading: false });
          }
        } else if (values.serviceGroupID !== servicesGroupsEnum.SALARY_ADVANCE_AND_MONEY_TRANSFER && this.region === Region.EG) {
          this.setState({ sheetsLoading: false });
        }
      }
    );
  };

  async setSheetsData() {
    const [
      allValid,
      meeza,
      cash,
      mobileWallet,
      [CIB, bankMisr, arabyBank, hsbcKsa],
    ] = await Promise.all([ // handles fetching all sheets data at once (concurrently)
      this.generateSheetsObjects(sheetsTypesEnum.allValid),
      this.generateSheetsObjects(sheetsTypesEnum.meeza),
      this.generateSheetsObjects(sheetsTypesEnum.cash),
      this.generateSheetsObjects(sheetsTypesEnum.mobileWallet),
      this.generateSheetsObjects(sheetsTypesEnum.allBanks),
      this.generateSheetsObjects(sheetsTypesEnum.hsbcKsa),
    ]);
    this.setState({
      sheetsData: {
        allValid,
        bankMisr,
        CIB,
        meeza,
        cash,
        mobileWallet,
        arabyBank,
        hsbcKsa
      }
    });



  }

  getSheetData(sheetType: sheetsTypesEnum) {
    switch (sheetType) {
      case sheetsTypesEnum.allValid: {
        if (this.state.sheetsData.allValid?.length) { return this.state.sheetsData.allValid; } break;
      }
      case sheetsTypesEnum.bankMisr: {
        if (this.state.sheetsData.bankMisr?.length) { return this.state.sheetsData.bankMisr; } break;
      }
      case sheetsTypesEnum.CIB: {
        if (this.state.sheetsData.CIB?.length) { return this.state.sheetsData.CIB; } break;
      }
      case sheetsTypesEnum.meeza: {
        if (this.state.sheetsData.meeza?.length) { return this.state.sheetsData.meeza; } break;
      }
      case sheetsTypesEnum.cash: {
        if (this.state.sheetsData.cash?.length) { return this.state.sheetsData.cash; } break;
      }
      case sheetsTypesEnum.mobileWallet: {
        if (this.state.sheetsData.mobileWallet?.length) { return this.state.sheetsData.mobileWallet; } break;
      }
      case sheetsTypesEnum.arabyBank: {
        if (this.state.sheetsData.arabyBank?.length) { return this.state.sheetsData.arabyBank; } break;
      }
      case sheetsTypesEnum.hsbcKsa: {
        if (this.state.sheetsData.hsbcKsa?.length) { return this.state.sheetsData.hsbcKsa; } break;
      }
    }

    message.error(`Can't download empty file`);
    return [];
  }

  onSearchFailed = (error: any) => {
    console.log(
      "🚀 ~ file: viewRequestsList.tsx ~ line 77 ~ ViewRequestsList ~ error",
      error
    );
  };

  refreshPage = () => {
    window.location.reload();
  };

  clearFilter = () => {
    const form = this.formFilterRef.current;
    form?.resetFields();
    form?.setFieldsValue({
      requestStatusID: this.state.defaultStatusName,
      userID: undefined,
      requestID: undefined,
      dateRange: undefined,
      serviceGroupID: undefined,
      companyID: undefined,
      deployed: 'All Companies',
      isACH: false,
    });
    this.setState(
      {
        loading: true,

        pagination: {
          ...this.state.pagination,
          current: 1,
        },
        filters: {
          userID: null,
          requestID: null,
          statusID: null,
          reasonID: null,
          dateFrom: null,
          dateTo: null,
          companyID: null,
          deployed: null,
          serviceGroupID: null,
          isACH: false,
        },
        canResetFilter: false,
        showBlockingIssuesCheckBox: false,
        currentStatus: 2,
        statusFilterSelected: statusesIDsEnum.processing,
        selectedCompany: false,
        selectedDeployType: false,
        serviceGroupIDSelected: 0,
        sheetsLoading: false,
      },
      () => this.getRequests()
    );
  };

  async componentDidMount() {

    await this.storeRequestStatuses()
    await this.storeCompanies();
    await this.storeServiceTypes()
    await this.getRequests()

  }
  changeStatus = (statusID: number) => {
    this.setState({ currentStatus: statusID })
  }
  changeCompany = (value: number) => {
    if (value) {
      this.setState({ selectedCompany: true });
      return

    }
    this.setState({ selectedCompany: false });
  }
  changeIsACH = () => {
    this.setState({ filters: { ...this.state.filters, isACH: !this.state.filters.isACH } });
  }
  changeDeployedType = (value: number) => {
    if (value) {
      this.setState({ selectedDeployType: true });
      return

    }
    this.setState({ selectedDeployType: false });
  }

  getOneServiceType = (service: number) => {
    this.setState({ serviceGroupIDSelected: service, canResetFilter: false })

    if (service === servicesGroupsEnum.SALARY_ADVANCE_AND_MONEY_TRANSFER) {
      this.setState({
        filters: { ...this.state.filters, isACH: true },
        showBlockingIssuesCheckBox: true,
      });
    } else { this.setState({ showBlockingIssuesCheckBox: false }); }
  }
  changeRequestStatus = (advanceID: number, statusRequestID: any) => {


    this.setState({ modalOn: true, selectedStatus: statusRequestID, advanceID: advanceID })
  }
  closeModal = () => {
    this.setState({ modalOn: false });
    this.commentRef.current?.resetFields();
    this.state.advanceID ? this.formRef.current[this.state.advanceID]!.resetFields() : this.formFilterRef.current!?.resetFields();

  }
  submitNewRequestStatus = async (values: { comment: string }) => {
    this.setState({ changeStatusBtn: true })
    const data = {
      newStatus: this.state.selectedStatus,
      advanceIDs: [this.state.advanceID],
      comment: values.comment,
    }
    try {
      const apiData: any = await this.props.request({
        url: changeRequestStatusApi, method: "PATCH",
        data: data,
      })
      const resp = apiData.data;
      if (resp.status === 200) {
        message.success(resp.message);
        this.getRequests();
        this.setState({ changeStatusBtn: false, modalOn: false });
        this.commentRef.current.resetFields();
        this.state.advanceID ? this.formRef.current[this.state.advanceID]!.resetFields() : this.formFilterRef.current!?.resetFields();

        return
      }
      message.error(resp.message);
    } catch (error: any) {
      message.error(error.response.data.message[0]);
      this.setState({ changeStatusBtn: false })
    }
  }

  getStatusByStatusID = (advancesStatusTypeID: number): string => {

    const status: any = this.state.statuses.find((status: any) => status.advancesStatusTypeID === advancesStatusTypeID);
    if (status) {
      return status.StatusType;
    }
    return '';
  };

  statusTagColor = (value: string) => {
    const status = value.toLowerCase();
    if (/(approv|success|complet|paid|active)/.test(status)) return "green";
    if (/(reject|declin|fail|cancel|block)/.test(status)) return "red";
    if (/(process|pending|review|hold)/.test(status)) return "gold";
    if (/(transfer|progress)/.test(status)) return "blue";
    return "default";
  };

  getActiveFilterChips = () => {
    const { filters, companies, serviceTypes, serviceGroupIDSelected, statusFilterSelected, canResetFilter, deployOptions, defaultStatusName } = this.state;

    const chips: { key: string; label: string; value: string; removable: boolean }[] = [];
    const statusName = this.getStatusByStatusID(statusFilterSelected) || defaultStatusName;
    if (statusName) chips.push({ key: "status", label: "Status", value: statusName, removable: false });
    if (!canResetFilter) return chips;
    if (filters.userID) chips.push({ key: "user", label: "User", value: String(filters.userID), removable: true });
    if (filters.requestID) chips.push({ key: "request", label: "Request", value: String(filters.requestID), removable: true });
    if (filters.dateFrom && filters.dateTo) {
      chips.push({
        key: "date",
        label: "Date",
        value: `${String(filters.dateFrom).slice(0, 10)} – ${String(filters.dateTo).slice(0, 10)}`,
        removable: true,
      });
    }
    if (filters.companyID) {
      const company: any = (companies as any[]).find((item) => item.id === filters.companyID);
      chips.push({ key: "company", label: "Company", value: company?.name || String(filters.companyID), removable: true });
    }
    const serviceId = filters.serviceGroupID || serviceGroupIDSelected;
    if (serviceId) {
      const service: any = (serviceTypes as any[]).find((item) => item.id === serviceId);
      if (service?.name) chips.push({ key: "service", label: "Service", value: service.name, removable: true });
    }
    if (this.region === Region.SE && filters.deployed !== null && filters.deployed !== undefined) {
      const option: any = (deployOptions as any[]).find((item) => item.id === filters.deployed);
      if (option?.name && option.name !== "All Companies") {
        chips.push({ key: "deployment", label: "Deployment", value: option.name, removable: true });
      }
    }
    if (filters.isACH) chips.push({ key: "issues", label: "Issues", value: "No blocking issues", removable: true });
    return chips;
  };

  removeFilter = (key: string) => {
    const form = this.formFilterRef.current;
    if (!form) return;

    const patch: any = {};
    let isACH = this.state.filters.isACH;

    if (key === "user") form.setFieldsValue({ userID: null });
    if (key === "request") form.setFieldsValue({ requestID: null });
    if (key === "date") form.setFieldsValue({ dateRange: null });
    if (key === "company") {
      form.setFieldsValue({ companyID: undefined });
      patch.selectedCompany = false;
    }
    if (key === "service") {
      form.setFieldsValue({ serviceGroupID: undefined, isACH: false });
      patch.serviceGroupIDSelected = 0;
      patch.showBlockingIssuesCheckBox = false;
      isACH = false;
    }
    if (key === "deployment") {
      form.setFieldsValue({ deployed: null });
      patch.selectedDeployType = false;
    }
    if (key === "issues") {
      form.setFieldsValue({ isACH: false });
      isACH = false;
    }

    if (Object.keys(patch).length) this.setState(patch);
    this.handleSearch({ ...form.getFieldsValue(), isACH });
  };

  render() {
    const {
      showBlockingIssuesCheckBox,
      requestsList, tableLoading, pagination, canResetFilter, pageLoading, errorView, errorMessage, statuses, modalOn, changeStatusBtn,
      defaultStatusName,
      //  isDownloadable,
      companies, deployOptions, selectedCompany, selectedDeployType, serviceTypes, serviceGroupIDSelected
    } = this.state;

    const dateFormat = "YYYY/MM/DD";

    const columnPriority = ["advanceID", "userName", "companyName", "amount", "transactionStatus", "dateOfRequest", "serviceTypeName", "phone", "userID", "numOfMonths", "bankName"];
    let columns = helper.generateTableColumns(this.state.requestsList).map((column: any) => {
      const key = String(column.dataIndex);
      const isStatus = /status/i.test(key);
      const isMoney = /amount|balance|payment/i.test(key);
      const titleWidth = Math.ceil(String(column.title).length * 9.5) + 64;
      const longestValue = this.state.requestsList.reduce((longest: number, row: any) => {
        const value = row?.[key];
        if (value === null || value === undefined || typeof value === "object") return longest;
        return Math.max(longest, String(value).length);
      }, 0);
      const contentWidth = Math.ceil(longestValue * 9) + (isStatus ? 72 : 56);
      return {
        ...column,
        className: isMoney ? "requestsList__money" : /phone|ID$/i.test(key) ? "requestsList__mono" : undefined,
        width: Math.max(titleWidth, contentWidth, isStatus ? 150 : 120),
        ellipsis: false,
        render: (value: any) => {
          if (value === null || value === undefined || value === "" || typeof value === "object") {
            return <span className="requestsList__empty">—</span>;
          }
          const text = String(value);
          if (isStatus) {
            return <Tag className="requestsList__tag" color={this.statusTagColor(text)}>{text}</Tag>;
          }
          return text;
        },
      };
    });
    columns.sort((a: any, b: any) => {
      const aIndex = columnPriority.indexOf(a.dataIndex);
      const bIndex = columnPriority.indexOf(b.dataIndex);
      return (aIndex === -1 ? columnPriority.length : aIndex) - (bIndex === -1 ? columnPriority.length : bIndex);
    });
    const addStatusSelection: any = {
      title: 'Change Request Status',
      key: 'changeStatus',
      width: 190,
      render: (_text: any, record: any) => {
        const options = Array.isArray(record.validStatuses)
          ? record.validStatuses.filter((status: any) => status.isValid)
          : [];
        if (!options.length) {
          return <span className="requestsList__empty">No actions</span>;
        }
        return (
          <Form
            className="requestsList__statusForm"
            name="nest-messages"
            ref={(el: any) => {
              if (!Array.isArray(this.formRef.current)) {
                this.formRef.current = [];
              }
              this.formRef.current[record.advanceID] = el
            }}
          >
            <Form.Item name={"status" + record.advanceID}>
              <Select
                placeholder="Change status"
                dropdownMatchSelectWidth={false}
                onChange={(e: any) => this.changeRequestStatus(record.advanceID, e)}
              >
                {options.map((status: any) => (
                  <Select.Option value={status.advancesStatusTypeID} key={status.advancesStatusTypeID}>{status.StatusType}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        );
      }
    }
    columns = [addStatusSelection, ...columns];
    const tableScrollX = columns.reduce((sum: number, column: any) => sum + (Number(column.width) || 140), 0);


    const nextStatusName = this.getStatusByStatusID(this.state.selectedStatus);
    const activeFilters = this.getActiveFilterChips();
    const statusLabel = this.getStatusByStatusID(this.state.statusFilterSelected) || defaultStatusName;
    const content = <>
      <div className='declineRequest requestsListConfirm'>
        <Form
          ref={this.commentRef}
          name="changeStatus"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={this.submitNewRequestStatus}
          autoComplete="off"
        >
          <p className='question'>Change request #{this.state.advanceID || "—"}?</p>
          {nextStatusName && (
            <div className="requestsListConfirm__target">
              <span>New status</span>
              <Tag className="requestsList__tag" color={this.statusTagColor(nextStatusName)}>{nextStatusName}</Tag>
            </div>
          )}

          <Form.Item name='comment' label="Comment (optional)">
            <Input.TextArea rows={3} placeholder="Why do you want to change the status?" />
          </Form.Item>
          <div className="requestsListConfirm__actions">
            <Button className='decline' onClick={this.closeModal}>Cancel</Button>
            <Button className='approve' htmlType="submit" loading={changeStatusBtn}>Confirm</Button>
          </div>

        </Form>
      </div>
    </>
    return pageLoading ? (
      <Spinner size="large" />
    ) : errorView ? (
      <OutPutResult status={"500"} title={"Oops!"}
        subTitle={
          errorMessage
            ? errorMessage
            : "Something went wrong, please refresh the page and try again"
        }
        btnTitle={"Refresh the page"}
        btnClick={this.refreshPage}
      />
    ) : (
      <div className="requestsList">
        <div className="requestsList__filters">
          <div className="requestsList__filtersHead">
            <div>
              <h3>Filters</h3>
                  <p>Choose filters, then click on the search button to apply the filters.</p>
            </div>
          </div>
          <Form
            ref={this.formFilterRef}
            name="basic"
            layout="vertical"
            colon={false}
            onFinish={this.handleSearch}
            onFinishFailed={this.onSearchFailed}
            autoComplete="off"
          >
            <div className="requestsList__filterGroups">
              <section className="requestsList__filterGroup">
                <span className="requestsList__groupTitle">Request</span>
                <Row gutter={[12, 0]}>
                  <Col xs={24} md={12} xl={10}>
                    <Form.Item label="Date" name="dateRange">
                      <RangePicker
                        format={dateFormat}
                        placeholder={["Start date", "End date"]}
                        ranges={{
                          Today: [moment(), moment()],
                          "Last 7 days": [moment().subtract(6, "days"), moment()],
                          "Last 30 days": [moment().subtract(29, "days"), moment()],
                          "This month": [moment().startOf("month"), moment().endOf("month")],
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={6} xl={7} className="requestsList__idField">
                    <Form.Item label="User ID" name="userID">
                      <InputNumber placeholder="User ID" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={6} xl={7} className="requestsList__idField">
                    <Form.Item label="Request ID" name="requestID">
                      <InputNumber placeholder="Request ID" />
                    </Form.Item>
                  </Col>
                </Row>
              </section>
              <section className="requestsList__filterGroup">
                <span className="requestsList__groupTitle">Scope</span>
                <Row gutter={[12, 0]}>
                  <Col xs={24} sm={12} lg={8} xl={6}>
                    <Form.Item label="Status" name="requestStatusID" initialValue={defaultStatusName} >
                      <Select placeholder="Select status" allowClear showSearch
                        onChange={this.changeStatus}
                        filterOption={((input, option: any) => helper.dropDownSearch(input, option))}
                      >
                        {Array.isArray(statuses) &&
                          statuses.map((status: any, key: any) => {
                            return <Select.Option value={status.advancesStatusTypeID} key={key}>{status.StatusType}</Select.Option>
                          })
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} lg={8} xl={6}>
                    <Form.Item label="Service group" name="serviceGroupID">
                      <Select placeholder="Any service" allowClear showSearch
                        onChange={this.getOneServiceType}
                        filterOption={((input, option: any) => helper.dropDownSearch(input, option))}>
                        {Array.isArray(serviceTypes) &&
                          serviceTypes.map((service: any, key: any) => {
                            return <Select.Option value={service.id} key={key}>{service.name}</Select.Option>
                          })
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} lg={8} xl={6}>
                    <Form.Item label="Company" name="companyID" extra={selectedDeployType ? "Clear deployment to choose one company." : undefined}>
                      <Select placeholder="Any company" disabled={selectedDeployType} showSearch allowClear
                        filterOption={((input, option: any) => helper.dropDownSearch(input, option))}
                        onChange={this.changeCompany}>
                        {Array.isArray(companies) &&
                          companies.map((company: any, key: any) => {
                            return <Select.Option value={company.id} key={key}>{company.name}</Select.Option>
                          })
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  {this.region === Region.SE && <Col xs={24} sm={12} lg={8} xl={6}>
                    <Form.Item label="Deployment" name="deployed" initialValue={'All Companies'} extra={selectedCompany ? "Clear the company to filter by deployment." : undefined}>
                      <Select disabled={selectedCompany} defaultValue={undefined} placeholder="All companies" allowClear onChange={this.changeDeployedType}>
                        {Array.isArray(deployOptions) &&
                          deployOptions.map((option: any, key: any) => {
                            return <Select.Option value={option.id} key={key}>{option.name}</Select.Option>
                          })
                        }
                      </Select>
                    </Form.Item>
                  </Col>}
                  {showBlockingIssuesCheckBox && (
                    <Col xs={24} sm={12} lg={8} xl={6}>
                      <Form.Item label="Issues" name="isACH" valuePropName="checked" initialValue={this.state.filters.isACH}>
                        <div className="requestsList__achControl">
                          <Checkbox checked={this.state.filters.isACH} onChange={this.changeIsACH} />
                          <span>No blocking issues</span>
                        </div>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </section>
            </div>
            <div className="requestsList__actions">
              <div className="requestsList__applied">
                    {activeFilters.map((chip) => (
                  <span className="requestsList__chip" key={chip.key}>
                    {chip.label}
                    <span>{chip.value}</span>
                    {chip.removable && (
                      <button type="button" aria-label={`Remove ${chip.label} filter`} onClick={() => this.removeFilter(chip.key)}>
                        <CloseOutlined />
                      </button>
                    )}
                  </span>
                ))}
              </div>
              <div className="requestsList__actionButtons">
                <Button icon={<ReloadOutlined />} htmlType="button" onClick={this.refreshPage}>
                  Refresh
                </Button>
                {(
                  requestsList.length !== 0 &&
                  [servicesGroupsEnum.SALARY_ADVANCE_AND_MONEY_TRANSFER].includes(serviceGroupIDSelected) &&
                  canResetFilter && (
                    this.state.statusFilterSelected === statusesIDsEnum.processing ||
                    this.state.statusFilterSelected === statusesIDsEnum.transferring)
                )
                  && (
                    <div className="requestsList__export">
                      <ExportToExcel
                        fileName={`${this.getStatusByStatusID(this.state.statusFilterSelected)} All valid requests`}
                        otherSheets={
                          this.region === Region.SE ? [
                            {
                              name: "All valid requests",
                              statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} All valid requests`,
                              onClick: () => this.getSheetData(sheetsTypesEnum.allValid),
                            },
                            {
                              name: "Bank misr Requests list",
                              statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)}  Bank misr Requests list`,
                              onClick: () => this.getSheetData(sheetsTypesEnum.bankMisr),
                            },
                            {
                              name: "CIB Requests list",
                              statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} CIB Requests list`,
                              onClick: () => this.getSheetData(sheetsTypesEnum.CIB),
                            },
                            {
                              name: "Meeza Requests list",
                              statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} Meeza Requests list`,
                              onClick: () => this.getSheetData(sheetsTypesEnum.meeza),
                            },
                            {
                              name: "Cash Requests list",
                              statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} Cash Requests list`,
                              onClick: () => this.getSheetData(sheetsTypesEnum.cash),
                            },
                            {
                              name: "Mobile Wallet Requests list",
                              statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} Mobile Wallet Requests list`,
                              onClick: () => this.getSheetData(sheetsTypesEnum.mobileWallet),
                            },
                            {
                              name: "Araby Bank Requests list",
                              statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} Araby Bank Requests list`,
                              onClick: () => this.getSheetData(sheetsTypesEnum.arabyBank),
                            },
                            {
                              name: "HSBC Bank Requests list",
                              statusName: `${this.getStatusByStatusID(this.state.statusFilterSelected)} HSBC Bank Requests list`,
                              onClick: () => {
                                const data = this.getSheetData(sheetsTypesEnum.hsbcKsa);
                                const [date] = new Date().toISOString().split('T')
                                exportTextFile(data, `ACH Batch ${date}`);
                                return data;
                              },
                            }
                            //Araby Bank type is here
                          ] : this.getOtherSheets()
                        }
                        loadingDataSheets={this.region === Region.SE ? false : this.state.sheetsLoading}
                      />
                    </div>
                  )}
                {canResetFilter && (
                  <Button danger htmlType="button" onClick={this.clearFilter}>
                    Clear filter
                  </Button>
                )}
                <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={tableLoading}>
                  Search
                </Button>
              </div>
            </div>
          </Form>
        </div>
        <div className="requestsList__table">
          <div className="requestsList__summary">
            <div>
              <strong>{pagination.total || 0}</strong>
              <span>{statusLabel ? ` ${statusLabel.toLowerCase()} requests` : " requests"}</span>
            </div>
            <span className="requestsList__summaryHint">Scroll sideways to see every column</span>
          </div>
          <DataTable
            columns={columns}
            rows={requestsList}
            handleTableChange={this.handlePagination}
            pagination={{
              ...pagination,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              showTotal: (total: number, range: [number, number]) => `${range[0]}–${range[1]} of ${total}`,
            }}
            loading={tableLoading}
            scrolling={{ x: tableScrollX, y: 'calc(100vh - 520px)' }}
            emptyText={(
              <div className="requestsList__emptyState">
                <strong>No requests to show</strong>
                <span>Try another status, date, or company.</span>
              </div>
            )}
            rowKey="advanceID"
            size="middle"
            bordered={false}
          />
        </div>
        <TruckingModal handleCloseModal={this.closeModal} visibleModal={modalOn} content={content} title={'Change request status'} width={480} />

      </div>
    );
  }
}

export default connect(null, { request })(ViewRequestsList);